export const WHATSAPP_NUMBER = "(31) 99305-3446";
export const WHATSAPP_URL =
  "https://wa.me/5531993053446?text=" +
  encodeURIComponent("Paz e bem! Gostaria de atendimento pastoral da DACB.");

export const SOCIALS = {
  facebook: "https://www.facebook.com/share/18EWnu4Y4z/",
  instagram: "https://www.instagram.com/dommacieira",
  youtube: "https://youtube.com/@exorcistadedeus",
};

export const MENU = [
  { label: "Início", id: "inicio", testid: "nav-home-link" },
  { label: "A Diocese", id: "a-diocese", testid: "nav-diocese-link" },
  { label: "Fé e Sacramentos", id: "fe-e-sacramentos", testid: "nav-fe-link" },
  { label: "Clero e Prelazias", id: "clero-e-prelazias", testid: "nav-clero-link" },
  { label: "Comunidades", id: "comunidades", testid: "nav-comunidades-link" },
  { label: "Notícias", id: "noticias", testid: "nav-noticias-link" },
  { label: "Documentos", id: "documentos", testid: "nav-documentos-link" },
  { label: "Contato", id: "contato", testid: "nav-contato-link" },
];

export const SEARCH_INDEX = [
  { label: "Conheça a Diocese", id: "a-diocese" },
  { label: "Governo Episcopal e Santo Sínodo", id: "governo-episcopal" },
  { label: "Fé e Sacramentos", id: "fe-e-sacramentos" },
  { label: "Clero e Prelazias", id: "clero-e-prelazias" },
  { label: "Aniversariantes do Clero", id: "aniversariantes" },
  { label: "Doações — Pix e transferência", id: "doacoes" },
  { label: "Sé Primacial — Esmeraldas/MG", id: "comunidades" },
  { label: "Agenda Litúrgica", id: "agenda" },
  { label: "Notícias", id: "noticias" },
  { label: "DACB ao Vivo", id: "ao-vivo" },
  { label: "Galeria de Fotos", id: "galeria" },
  { label: "Atendimento Pastoral", id: "atendimento" },
  { label: "Documentos", id: "documentos" },
  { label: "Contato", id: "contato" },
];

export const HIGHLIGHTS = [
  {
    id: "a-diocese",
    testid: "highlight-card-conheca",
    icon: "Church",
    title: "Conheça a Diocese",
    desc: "História, identidade, missão e estrutura eclesiástica",
  },
  {
    id: "comunidades",
    testid: "highlight-card-comunidade",
    icon: "MapPin",
    title: "Encontre uma Comunidade",
    desc: "Prelazias, missões, comunidades e pontos missionários no Brasil",
  },
  {
    id: "agenda",
    testid: "highlight-card-agenda",
    icon: "Calendar",
    title: "Agenda Litúrgica",
    desc: "Missas, festas, visitas pastorais e atividades",
  },
  {
    id: "atendimento",
    testid: "highlight-card-atendimento",
    icon: "HeartHandshake",
    title: "Atendimento Pastoral",
    desc: "Orações, sacramentos, casamento, batismo e vocações",
  },
];

export const MARQUEE_ITEMS = [
  "Fé Católica",
  "Tradição Anglicana",
  "Missão no Brasil",
  "Anglican Free Communion International",
  "Sucessão Apostólica",
  "Sé Primacial — Esmeraldas/MG",
  "Para que todos sejam um — Jo 17,21",
];

export const MANIFESTO_CHAPTERS = [
  {
    number: "01",
    title: "Fé Apostólica e Vida Sacramental",
    content:
      "Guardamos integralmente a fé dos credos ecumênicos, a sucessão apostólica ininterrupta e a celebração digna dos sacramentos instituídos por Nosso Senhor Jesus Cristo.",
  },
  {
    number: "02",
    title: "Tradição Anglicana em Comunhão",
    content:
      "Em comunhão com a Anglican Free Communion International, unimos a riqueza da liturgia e do patrimônio anglicano ao fervor missionário do povo brasileiro.",
  },
  {
    number: "03",
    title: "Missão junto ao Povo Brasileiro",
    content:
      "Presentes na vida do povo através do acolhimento espiritual, da formação catequética, das obras de misericórdia e do anúncio corajoso do Evangelho.",
  },
];

export const SACRAMENTS = [
  { numeral: "I", name: "Santo Batismo", desc: "O nascimento para a vida em Cristo e a incorporação à Igreja." },
  { numeral: "II", name: "Sagrada Eucaristia", desc: "O centro da vida da Igreja: o Corpo e o Sangue do Senhor." },
  { numeral: "III", name: "Confirmação", desc: "O fortalecimento dos dons do Espírito Santo na vida do fiel." },
  { numeral: "IV", name: "Reconciliação", desc: "A confissão e o perdão misericordioso de Deus aos penitentes." },
  { numeral: "V", name: "Unção dos Enfermos", desc: "A oração da fé e a santa unção pela saúde do corpo e da alma." },
  { numeral: "VI", name: "Sagrada Ordem", desc: "O ministério ordenado a serviço do Evangelho e dos sacramentos." },
  { numeral: "VII", name: "Santo Matrimônio", desc: "A aliança de amor abençoada por Deus entre os esposos." },
];

export const SE_PRIMACIAL = {
  categoria: "Sé Primacial",
  nome: "Paróquia Santo Expedito e Nossa Senhora Desatadora dos Nós",
  endereco: ["Rua 1, nº 650", "Bairro Monte Sinai", "Esmeraldas — Minas Gerais"],
};

export const SHORTCUTS = [
  { testid: "pastoral-shortcut-batismo", icon: "Droplets", title: "Batismo", target: "contato" },
  { testid: "pastoral-shortcut-matrimonio", icon: "Heart", title: "Matrimônio", target: "contato" },
  { testid: "pastoral-shortcut-vocacoes", icon: "Flame", title: "Vocações", target: "contato" },
  { testid: "pastoral-shortcut-catequese", icon: "BookOpen", title: "Catequese", target: "contato" },
  { testid: "pastoral-shortcut-documentos", icon: "FileText", title: "Documentos", target: "documentos" },
  { testid: "pastoral-shortcut-seminario", icon: "GraduationCap", title: "Seminário STIA-DACB", target: "contato" },
  { testid: "pastoral-shortcut-doacoes", icon: "HandCoins", title: "Doações", target: "doacoes" },
];

export const DOCUMENTS = [
  { title: "Estatuto Diocesano", desc: "Normas fundamentais de fé, governo e disciplina da DACB." },
  { title: "Cartas Pastorais", desc: "Orientações dos bispos às comunidades e ao clero diocesano." },
  { title: "Decretos e Comunicados", desc: "Atos oficiais da Chancelaria e do Colégio Episcopal." },
];

export const IMAGES = {
  hero: "/img/hero.webp",
  cathedral: "/img/cathedral.webp",
  altar: "/img/altar.webp",
  monstrance: "/img/monstrance.webp",
  candles: "/img/candles.webp",
  crucifix: "/img/crucifix.webp",
};
